/**
 * Expand's an element's height from the current
 * set height to the needed height of the element.
 * @param element The element to animate
 * @param time The amount of time in milliseconds for the duration of the animation
 */
export function expandHeight(element : JQuery, time : number){
    let curHeight = element.height(), // Get Default Height
        autoHeight = element.css('height', 'auto').height(); // Get Auto Height
    element.height(curHeight); // Reset to Default Height
    element.stop().animate({ height: autoHeight }, time); // Animate to Auto Height
}



// WEBPACK FOOTER //
// ./assets/ts/src/pollenCount/Animation.ts